var scope_0 = require('/home/runner/work/sencrop-developer-platform/sencrop-developer-platform/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6d2c1bb12f5c939b9aba5e9b95714107.js').default;
var scope_1 = require('/home/runner/work/sencrop-developer-platform/sencrop-developer-platform/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/home/runner/work/sencrop-developer-platform/sencrop-developer-platform/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f356ba0d2ac97183e39f91c925e58d5e.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    